import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyCTTi_xNzkzzeX-bju5W-71uiMGTB85PWk",
  authDomain: "messx-544ef.firebaseapp.com",
  projectId: "messx-544ef",
  storageBucket: "messx-544ef.appspot.com",
  messagingSenderId: "752627503825",
  appId: "1:752627503825:web:038005a0027a8dcf566bf0",
};

const app = !firebase.apps.length
  ? firebase.initializeApp(firebaseConfig)
  : firebase.app();

const db = app.firestore();
const auth = app.auth();
const provider = new firebase.auth.GoogleAuthProvider();

export { db, auth, provider };
